import { Mail } from "lucide-react";
import { InstagramIcon } from "./InstagramIcon";
import { Reveal } from "./Reveal";

const CONTACTOS = [
  {
    id: "instagram-pzicodosis",
    Icon: InstagramIcon,
    eyebrow: "Instagram PzicoDosis",
    label: "@pzicodosis",
    sub: "Síguenos para contenido diario",
    href: "https://www.instagram.com/pzicodosis",
    external: true,
  },
  {
    id: "instagram-fundador",
    Icon: InstagramIcon,
    eyebrow: "Instagram personal",
    label: "Gamaliel Castro — @castro_3003",
    sub: "Conoce más sobre el fundador",
    href: "https://www.instagram.com/castro_3003",
    external: true,
  },
  {
    id: "email",
    Icon: Mail,
    eyebrow: "Escríbenos",
    label: "psicodosis2024@gmail.com",
    sub: "Te respondemos pronto",
    href: "mailto:psicodosis2024@gmail.com",
    external: false,
  },
];

export function Contacto() {
  return (
    <div className="contacto-section">
      <div className="container" style={{ padding: "70px 0" }}>
        <Reveal>
          <div style={{ textAlign: "center", marginBottom: 52 }}>
            <h2 className="section-title-display fluid-heading-md" style={{ marginBottom: 10 }}>
              ¿Tienes dudas? Hablemos
            </h2>
            <p style={{ fontSize: 17, color: "var(--muted)", margin: 0 }}>
              Estamos aquí para acompañarte
            </p>
          </div>
        </Reveal>

        <div className="contacto-grid">
          {CONTACTOS.map((c, i) => (
            <Reveal key={c.id} style={{ transitionDelay: `${i * 100}ms` }}>
              <a
                href={c.href}
                {...(c.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="contacto-card"
              >
                <span className="contacto-card__icon">
                  <c.Icon size={26} color="#fff" strokeWidth={2} />
                </span>
                <span className="contacto-card__eyebrow">{c.eyebrow}</span>
                <span className="contacto-card__label">{c.label}</span>
                <span className="contacto-card__sub">{c.sub}</span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
